import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="w-full bg-white border-b border-gray-100 sticky top-0 z-50 shadow-sm" data-id="element-319">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-320">
        <div className="flex justify-between items-center py-4" data-id="element-321">
          <div className="flex items-center" data-id="element-322">
            <a href="/" className="flex items-center" data-id="element-323">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5M1Z6zqeGYA3RVe55Wm1x8/Logo_purple_horizontal.png" alt="Nexio Logo" className="h-44 w-auto" data-id="element-324" />
            </a>
          </div>
          <nav className="hidden md:flex space-x-8" data-id="element-325">
            <a href="#features" className="text-gray-600 hover:text-[#9333EA] font-medium transition-colors" data-id="element-326">
              Features
            </a>
            <a href="#use-cases" className="text-gray-600 hover:text-[#9333EA] font-medium transition-colors" data-id="element-327">
              Use Cases
            </a>
            <a href="#comparison" className="text-gray-600 hover:text-[#9333EA] font-medium transition-colors" data-id="element-328">
              Why Nexio
            </a>
            <a href="#pricing" className="text-gray-600 hover:text-[#9333EA] font-medium transition-colors" data-id="element-329">
              Pricing
            </a>
          </nav>
          <div className="hidden md:flex items-center space-x-4" data-id="element-330">
            <a href="#" className="text-gray-600 hover:text-[#9333EA] font-medium transition-colors" data-id="element-331">
              Login
            </a>
            <Button href="https://nexioapp.eu/dashboard/register" data-id="element-332">
              Get Started
            </Button>
            <Button variant="outline" href="https://calendar.app.google/6fKsGXEmBQzjPvnc9" data-id="element-333">
              Plan a Demo
            </Button>
          </div>
          <div className="md:hidden" data-id="element-334">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-500 hover:text-gray-600 focus:outline-none p-2" aria-label="Toggle menu" data-id="element-335">
              {isMenuOpen ? <XIcon size={24} data-id="element-336" /> : <MenuIcon size={24} data-id="element-337" />}
            </button>
          </div>
        </div>
        {isMenuOpen && <div className="md:hidden py-4 border-t border-gray-100 animate-fadeIn" data-id="element-338">
            <div className="flex flex-col space-y-4 pb-4" data-id="element-339">
              <a href="#features" className="text-gray-600 hover:text-[#9333EA] font-medium transition-colors px-2 py-1" data-id="element-340">
                Features
              </a>
              <a href="#use-cases" className="text-gray-600 hover:text-[#9333EA] font-medium transition-colors px-2 py-1" data-id="element-341">
                Use Cases
              </a>
              <a href="#comparison" className="text-gray-600 hover:text-[#9333EA] font-medium transition-colors px-2 py-1" data-id="element-342">
                Why Nexio
              </a>
              <a href="#pricing" className="text-gray-600 hover:text-[#9333EA] font-medium transition-colors px-2 py-1" data-id="element-343">
                Pricing
              </a>
              <a href="#" className="text-gray-600 hover:text-[#9333EA] font-medium transition-colors px-2 py-1" data-id="element-344">
                Login
              </a>
              <div className="pt-2" data-id="element-345">
                <Button className="w-full mb-3" href="https://nexioapp.eu/dashboard/register" data-id="element-346">
                  Get Started
                </Button>
                <Button variant="outline" className="w-full" href="https://calendar.app.google/6fKsGXEmBQzjPvnc9" data-id="element-347">
                  Plan a Demo
                </Button>
              </div>
            </div>
          </div>}
      </div>
    </header>;
}